export default {
    roles: '', // muchos roles
    rol:'',//usado para un rol individual editar o eliminar
    error: false,
    errorMessage: '',
    

  }